import _get from 'lodash/get';
import _set from 'lodash/set';
import _merge from 'lodash/merge';
import { LAYOUT_ALIASES, LAYOUT_ENTITIES, LAYOUT_FRONTSPACES } from '@bedrock/fido-sdk';
import { navigateToLandingPage, navigateToPairingPage } from '../../modules/routes/routes.utils';
import { REFRESH_AUTH, REQUIRE_AUTH } from '../pairing/pairing.constants';
import { getOpenCatalogFeature } from '../features/features.selectors';
import { getCurrentSectionCode } from '../layout/layout.selectors';
import { setDeeplinkLocation } from '../routing/routing.actions';
import { getPreviousProfileUid } from '../user/user.selectors';
import { resetJwtProfile } from '../token/token.actions';
import { showPopupAction } from '../popup/popup.actions';
import { clearCache } from '../layout/layout.actions';
import { logout } from '../pairing/pairing.actions';
import { reset } from '../player/player.constants';
import { refreshAuth } from './refreshAuth.lock.actions';
import { getDeeplinkFromLock, getMappedLockPopup, getReason, getReasonAttributes } from './lock.utils';

export const unlockByAuth = item => async (dispatch, getState) => {
  const state = getState();

  dispatch(reset());

  if (getOpenCatalogFeature(state)) {
    const deeplink = getDeeplinkFromLock(item);
    if (deeplink) {
      dispatch(setDeeplinkLocation(deeplink));
    }
    navigateToPairingPage();
  } else {
    await dispatch(logout());

    navigateToLandingPage();
  }
};

/**
 * Creates item-dependent action that dispatches appropriate Redux actions
 *
 * @param {Object} actionOptions metadata
 * @param {Object} actionOptions.item item metadata, as retrieved from layout
 * @param {Object} actionOptions.isLive is content is Live
 * @param {string} actionOptions.layout layout object, required for Lock actions
 * @param {string} actionOptions.entityId layout entity ID, required for player initialization
 * @param {Object} lockOptions options for popups (flags, payload, strings)
 */
// eslint-disable-next-line no-unused-vars
export const handleLock = (actionOptions, lockOptions) => async (dispatch, getState) => {
  const reason = getReason(actionOptions);
  if (reason === REQUIRE_AUTH) {
    dispatch(unlockByAuth(actionOptions.item));

    return;
  }

  if (reason === REFRESH_AUTH) {
    dispatch(refreshAuth(actionOptions));

    return;
  }

  const lock = _get(actionOptions, 'item.action.target.value_lock');
  // copy an action and replace lock target with `value_lock.originalTarget` to avoid mutation of origin dataset
  const payload = _set(_merge({}, actionOptions), 'item.action.target', lock ? lock.originalTarget : null);

  dispatch(
    showPopupAction(getMappedLockPopup(reason), {
      ...lockOptions,
      lock,
      payload,
    }),
  );
};
export const SHOW_PROFILES_GATE = 'lock/SHOW_PROFILES_GATE';

export const disableProfileAutoSelect = () => ({
  type: SHOW_PROFILES_GATE,
});

export const clearAfterProfileChanged = () => (dispatch, getState) => {
  const section = getCurrentSectionCode(getState());
  dispatch(disableProfileAutoSelect());
  dispatch(resetJwtProfile());
  dispatch(reset());
  dispatch(clearCache(LAYOUT_ENTITIES.alias, LAYOUT_ALIASES.home, section));
  dispatch(clearCache(LAYOUT_ENTITIES.frontspace, LAYOUT_FRONTSPACES.bookmarks, section));
};

export const checkProfileAutoSelect = data => (dispatch, getState) => {
  const items = _get(data, 'blocks[0].content.items', []);

  if (items.length === 1) {
    const { profileUid } = getReasonAttributes(items[0]);
    if (getPreviousProfileUid(getState()) !== profileUid) {
      dispatch(disableProfileAutoSelect());
    }
  }
};
